module.exports = "https://bicocca-network.servercdn.it/static/img/story3.jpg?9b7f20681d25facf7fb3db7db537d037";